import { useState, useEffect } from "react";
import { Modal, Col, Row } from "antd";
import { Flex, Box, Text } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "components/Button/PrimaryButton";
import SelectOrderDirection from "components/Input/SelectOrderDirection/index";
import SelectOrderBy from "components/Input/SelectOrderBy/index";

interface ModalOrderByProps {
  onClose: () => void;
  openModal: boolean;
  onOrderDirectionChange: (q?: string) => void;
  orderDirection?: string | undefined;
  onOrderByChange: (q?: string) => void;
  orderBy?: string | undefined;
  options: {
    value: string;
    label: string;
  }[];
}

export default function ModalOrderBy({
  onClose,
  openModal,
  orderDirection,
  onOrderDirectionChange,
  orderBy,
  onOrderByChange,
  options,
}: ModalOrderByProps) {
  const [localFiltro, setLocalFiltro] = useState({
    orderBy,
    orderDirection,
  });

  useEffect(() => {
    if (!openModal) {
      setLocalFiltro({
        orderBy,
        orderDirection,
      });
    }
  }, [openModal, orderBy, orderDirection]);

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      width="500px"
      visible={openModal}
      footer={
        <Flex flex={1} justifyContent="end" gap={4}>
          <OutlineButton onClick={onClose}>Cancelar</OutlineButton>
          <PrimaryButton
            onClick={() => {
              onOrderDirectionChange(localFiltro.orderDirection);
              onOrderByChange(localFiltro.orderBy);
              onClose();
            }}
          >
            Ordenar
          </PrimaryButton>
        </Flex>
      }
    >
      <Text mb={4} fontWeight="bold" fontSize="16px">
        Selecione o tipo de ordenação
      </Text>
      <Box as={Row} gutter={16} mb={4}>
        <Col md={12}>
          <SelectOrderBy
            allowClear={false}
            value={localFiltro.orderBy}
            onChange={(v) =>
              setLocalFiltro((state) => ({ ...state, orderBy: v }))
            }
            options={options}
          />
        </Col>
        <Col md={12}>
          <SelectOrderDirection
            allowClear={false}
            value={localFiltro.orderDirection}
            onChange={(v) =>
              setLocalFiltro((state) => ({ ...state, orderDirection: v }))
            }
          />
        </Col>
      </Box>
    </Modal>
  );
}
